export default __webpack_public_path__ + "../staticImages/sprite-forecast-dhl_express-2x.png";